import { useEffect, useState } from 'react'
import Input from '../components/Input'
import { onChange } from '../utils/functions'
import Button from '../components/Button'
import { useApiProgress } from '../hooks/ApiProgress'
import { USER_PATH, login } from '../api/userApi'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { loginAction } from '../redux/feature/authSlice'
import { useNavigate } from 'react-router-dom'

const LoginPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const [credentials, setCredentials] = useState({
        username: "",
        password: ""
    })
    const [showPassword, setShowPassword] = useState(false)
    const pendingApiCall = useApiProgress('post', `/api/v1/auth`, true)

    const [errors, setErrors] = useState({})
    const dispatch = useDispatch()
    const nav = useNavigate()

    const onClickSubmit = () => {
        login(credentials)
            .then(res => {
                toast.success('Hoşgeldiniz')
                dispatch(loginAction(res.data))
                nav('/')
            }).catch(err => {
                toast.error('Geçersiz şifre veya parola')
                // setCredentials({
                //     username: "",
                //     password: ""
                // })
            })
    }

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Giriş</label>
                <Input
                    label='Kullanıcı Adı'
                    name='username'
                    placeholder='Kullanıcı adı girin...'
                    value={credentials.username}
                    error={errors.username}
                    autoComplete="username"
                    onChange={e => onChange(e, setCredentials, setErrors)}
                />
                <Input
                    label='Şifre'
                    type={showPassword ? 'text' : "password"}
                    name='password'
                    placeholder='Şifre girin...'
                    value={credentials.password}
                    error={errors.password}
                    autoComplete="current-password"
                    onChange={e => onChange(e, setCredentials, setErrors)}
                />
                <div className='flex gap-x-2 items-center'>
                    <input
                        id='show'
                        type='checkbox'
                        onChange={e => setShowPassword(e.target.checked)}
                    />
                    <label htmlFor='show'>Şifreyi göster</label>
                </div>
                <div className='flex justify-center'>
                    <Button
                        text='Giriş'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default LoginPage